import { defineMessages } from 'react-intl';
import { passengerFormValidationErrorMessageId } from './View/userPassengers/constants';

export const accountProfileScope = 'app.containers.accountProfile';

export const accountProfileMessages = {
  welcome: {
    id: `${accountProfileScope}.welcome`,
    defaultMessage: 'Bienvenue,',
    en: 'Welcome,',
    es: 'Bienvenido,',
    it: 'Benvenuto,',
    de: 'Willkommen,',
    nl: 'Welkom,',
  },
  travelerProfiles: {
    id: `${accountProfileScope}.travelerProfiles`,
    defaultMessage: 'Profils voyageurs',
    en: 'Traveler Profiles',
    es: 'Perfiles de viajeros',
    it: 'Profili viaggiatori',
    de: 'Reiseprofile',
    nl: 'Reizigersprofielen',
  },

  deleteIdentityDocument: {
    id: `${accountProfileScope}.deleteIdentityDocument`,
    defaultMessage: "Supprimer ce document d'identité",
    en: 'Delete this identity document',
    es: 'Eliminar este documento de identidad',
    it: "Elimina questo documento d'identità",
    de: 'Dieses Ausweisdokument löschen',
    nl: 'Verwijder dit identiteitsdocument',
  },
  identityDocument: {
    id: `${accountProfileScope}.identityDocument`,
    defaultMessage: "Document d'identité",
    en: 'Identity document',
    es: 'Documento de identidad',
    it: "Documento d'identità",
    de: 'Ausweisdokument',
    nl: 'Identiteitsdocument',
  },
  removeDiscountCard: {
    id: `${accountProfileScope}.removeDiscountCard`,
    defaultMessage: 'Supprimer cette carte de réduction',
    en: 'Remove this discount card',
    es: 'Eliminar esta tarjeta de descuento',
    it: 'Rimuovi questa carta sconto',
    de: 'Diese Rabattkarte entfernen',
    nl: 'Verwijder deze kortingskaart',
  },
  discountCardType: {
    id: `${accountProfileScope}.discountCardType`,
    defaultMessage: 'Type de carte',
    en: 'Card type',
    es: 'Tipo de tarjeta',
    it: 'Tipo di carta',
    de: 'Kartentyp',
    nl: 'Kaarttype',
  },
  discountCard: {
    id: `${accountProfileScope}.discountCard`,
    defaultMessage: 'Carte de réduction',
    en: 'Discount card',
    es: 'Tarjeta de descuento',
    it: 'Carta sconto',
    de: 'Ermäßigungskarte',
    nl: 'Kortingskaart',
  },
  addDiscountCard: {
    id: `${accountProfileScope}.addDiscountCard`,
    defaultMessage: 'Ajouter une carte de réduction',
    en: 'Add a discount card',
    es: 'Agregar una tarjeta de descuento',
    it: 'Aggiungi una carta sconto',
    de: 'Eine Ermäßigungskarte hinzufügen',
    nl: 'Voeg een kortingskaart toe',
  },
  addIdentityDocument: {
    id: `${accountProfileScope}.addIdentityDocument`,
    defaultMessage: "Ajouter une pièce d'identité",
    en: 'Add Identity Document',
    es: 'Agregar documento de identidad',
    it: "Aggiungi documento d'identità",
    de: 'Identitätsdokument hinzufügen',
    nl: 'Identiteitsbewijs toevoegen',
  },
  removeFavoritePassenger: {
    id: `${accountProfileScope}.removeFavoritePassenger`,
    defaultMessage: 'Supprimer ce passager favori',
    en: 'Remove this favorite passenger',
    es: 'Eliminar este pasajero favorito',
    it: 'Rimuovi questo passeggero preferito',
    de: 'Diesen bevorzugten Passagier entfernen',
    nl: 'Verwijder deze favoriete passagier',
  },
  optionalEmailAddress: {
    id: `${accountProfileScope}.optionalEmailAddress`,
    defaultMessage: 'Adresse email (facultatif)',
    en: 'Email address (optional)',
    es: 'Dirección de correo electrónico (opcional)',
    it: 'Indirizzo email (facoltativo)',
    de: 'E-Mail-Adresse (optional)',
    nl: 'E-mailadres (optioneel)',
  },
  newPassenger: {
    id: `${accountProfileScope}.newPassenger`,
    defaultMessage: 'Nouveau passager',
    en: 'New passenger',
    es: 'Nuevo pasajero',
    it: 'Nuovo passeggero',
    de: 'Neuer Passagier',
    nl: 'Nieuwe passagier',
  },
  modifyOrDelete: {
    id: `${accountProfileScope}.modifyOrDelete`,
    defaultMessage: 'Modifier ou supprimer',
    en: 'Modify or delete',
    es: 'Modificar o eliminar',
    it: 'Modifica o elimina',
    de: 'Ändern oder löschen',
    nl: 'Wijzig of verwijder',
  },
  noDiscountCard: {
    id: `${accountProfileScope}.noDiscountCard`,
    defaultMessage: 'Aucune carte de réduction',
    en: 'No discount card',
    es: 'Ninguna tarjeta de descuento',
    it: 'Nessuna carta sconto',
    de: 'Keine Ermäßigungskarte',
    nl: 'Geen kortingskaart',
  },
  discountCardName: {
    id: `${accountProfileScope}.discountCardName`,
    defaultMessage: 'Carte {cardName}',
    en: 'Card {cardName}',
    es: 'Tarjeta {cardName}',
    it: 'Carta {cardName}',
    de: 'Karte {cardName}',
    nl: 'Kaart {cardName}',
  },
  noRegisteredPassengers: {
    id: `${accountProfileScope}.noRegisteredPassengers`,
    defaultMessage: "Vous n'avez pas de passagers enregistrés pour le moment.",
    en: 'You have no registered passengers at the moment.',
    es: 'No tienes pasajeros registrados en este momento.',
    it: 'Non hai passeggeri registrati al momento.',
    de: 'Sie haben momentan keine registrierten Passagiere.',
    nl: 'Je hebt op dit moment geen geregistreerde passagiers.',
  },
  addFavoritePassenger: {
    id: `${accountProfileScope}.addFavoritePassenger`,
    defaultMessage: 'Ajouter un passager favori',
    en: 'Add a favorite passenger',
    es: 'Agregar un pasajero favorito',
    it: 'Aggiungi un passeggero preferito',
    de: 'Einen Favoritenpassagier hinzufügen',
    nl: 'Voeg een favoriete passagier toe',
  },
  yourPassengers: {
    id: `${accountProfileScope}.yourPassengers`,
    defaultMessage: 'Vos passagers',
    en: 'Your passengers',
    es: 'Sus pasajeros',
    it: 'I tuoi passeggeri',
    de: 'Ihre Passagiere',
    nl: 'Uw passagiers',
  },
  modifyPassenger: {
    id: `${accountProfileScope}.modifyPassenger`,
    defaultMessage: "Modification d'un passager",
    en: 'Modify a passenger',
    es: 'Modificar un pasajero',
    it: 'Modifica un passeggero',
    de: 'Passagier ändern',
    nl: 'Passagier wijzigen',
  },
  addPassenger: {
    id: `${accountProfileScope}.addPassenger`,
    defaultMessage: "Ajout d'un passager",
    en: 'Add a passenger',
    es: 'Agregar un pasajero',
    it: 'Aggiungi un passeggero',
    de: 'Passagier hinzufügen',
    nl: 'Voeg een passagier toe',
  },
  validate: {
    id: `${accountProfileScope}.validate`,
    defaultMessage: 'Valider',
    en: 'Validate',
    es: 'Validar',
    it: 'Convalidare',
    de: 'Bestätigen',
    nl: 'Valideren',
  },

  addNewFavoritePassengers: {
    id: `${accountProfileScope}.addNewFavoritePassengers`,
    defaultMessage: 'Vous pouvez ajouter de nouveaux passagers favoris.',
    en: 'You can add new favorite passengers.',
    es: 'Puedes agregar nuevos pasajeros favoritos.',
    it: 'Puoi aggiungere nuovi passeggeri preferiti.',
    de: 'Sie können neue Lieblingspassagiere hinzufügen.',
    nl: 'U kunt nieuwe favoriete passagiers toevoegen.',
  },
  directlyOnThisPage: {
    id: `${accountProfileScope}.directlyOnThisPage`,
    defaultMessage: 'Directement sur cette page.',
    en: 'Directly on this page.',
    es: 'Directamente en esta página.',
    it: 'Direttamente su questa pagina.',
    de: 'Direkt auf dieser Seite.',
    nl: 'Direct op deze pagina.',
  },
  passengersCanBeRegistered: {
    id: `${accountProfileScope}.passengersCanBeRegistered`,
    defaultMessage:
      'À chaque commande, les passagers peuvent être enregistrés.',
    en: 'With each order, passengers can be registered.',
    es: 'Con cada pedido, se pueden registrar pasajeros.',
    it: 'Ad ogni ordine, i passeggeri possono essere registrati.',
    de: 'Bei jeder Bestellung können Passagiere registriert werden.',
    nl: 'Bij elke bestelling kunnen passagiers worden geregistreerd.',
  },
  noLimitOnFavoritePassengers: {
    id: `${accountProfileScope}.noLimitOnFavoritePassengers`,
    defaultMessage: 'Aucune limite de passagers favoris.',
    en: 'No limit on favorite passengers.',
    es: 'Sin límite en los pasajeros favoritos.',
    it: 'Nessun limite per i passeggeri preferiti.',
    de: 'Keine Begrenzung für Favoritenpassagiere.',
    nl: 'Geen limiet voor favoriete passagiers.',
  },

  reservations: {
    id: `${accountProfileScope}.reservations`,
    defaultMessage: 'Réservations',
    en: 'Reservations',
    es: 'Reservas',
    it: 'Prenotazioni',
    de: 'Reservierungen',
    nl: 'Reserveringen',
  },
  customerService: {
    id: `${accountProfileScope}.customerService`,
    defaultMessage: 'Service client',
    en: 'Customer Service',
    es: 'Servicio al Cliente',
    it: 'Servizio Clienti',
    de: 'Kundenservice',
    nl: 'Klantenservice',
  },
  settings: {
    id: `${accountProfileScope}.settings`,
    defaultMessage: 'Paramètres',
    en: 'Settings',
    es: 'Configuraciones',
    it: 'Impostazioni',
    de: 'Einstellungen',
    nl: 'Instellingen',
  },
  paymentMethods: {
    id: `${accountProfileScope}.paymentMethods`,
    defaultMessage: 'Moyens de paiement',
    en: 'Payment Methods',
    es: 'Métodos de pago',
    it: 'Metodi di pagamento',
    de: 'Zahlungsmethoden',
    nl: 'Betaalmethoden',
  },
  discountCards: {
    id: `${accountProfileScope}.discountCards`,
    defaultMessage: 'Cartes de réduction',
    en: 'Discount Cards',
    es: 'Tarjetas de descuento',
    it: 'Carte sconto',
    de: 'Rabattkarten',
    nl: 'Kortingskaarten',
  },

  [passengerFormValidationErrorMessageId.GENERIC]: {
    id: `${accountProfileScope}.${passengerFormValidationErrorMessageId.GENERIC}`,
    defaultMessage: 'Veuillez entrer une valeur valide pour ce champ.',
    en: 'Please enter a valid value for this field.',
    it: 'Si prega di inserire un valore valido per questo campo.',
    es: 'Por favor, ingrese un valor válido para este campo.',
    de: 'Bitte geben Sie einen gültigen Wert für dieses Feld ein.',
    nl: 'Voer een geldige waarde in voor dit veld.',
  },
  [passengerFormValidationErrorMessageId.INVALID_EMAIL]: {
    id: `${accountProfileScope}.${passengerFormValidationErrorMessageId.INVALID_EMAIL}`,
    defaultMessage: 'Veuillez saisir une adresse e-mail valide.',
    en: 'Please enter a valid email address.',
    it: 'Si prega di inserire un indirizzo email valido.',
    es: 'Por favor, ingrese una dirección de correo electrónico válida.',
    de: 'Bitte geben Sie eine gültige E-Mail-Adresse ein.',
    nl: 'Voer een geldig e-mailadres in.',
  },
  [passengerFormValidationErrorMessageId.INVALID_DATE]: {
    id: `${accountProfileScope}.${passengerFormValidationErrorMessageId.INVALID_DATE}`,
    defaultMessage:
      'La date saisie est invalide. Veuillez vérifier votre saisie.',
    en: 'The entered date is invalid. Please check your input.',
    it: "La data inserita non è valida. Si prega di controllare l'inserimento.",
    es: 'La fecha ingresada no es válida. Por favor, verifique su entrada.',
    de: 'Das eingegebene Datum ist ungültig. Bitte überprüfen Sie Ihre Eingabe.',
    nl: 'De ingevoerde datum is ongeldig. Controleer uw invoer.',
  },

  unexpectedError: {
    id: `${accountProfileScope}.unexpectedError`,
    defaultMessage:
      "Une erreur inattendue s'est produite. Veuillez réessayer ou contacter le support si le problème persiste.",
    en: 'An unexpected error occurred. Please try again or contact support if the problem persists.',
    es: 'Se produjo un error inesperado. Vuelva a intentarlo o contacte con el soporte si el problema persiste.',
    it: 'Si è verificato un errore imprevisto. Riprova o contatta il supporto se il problema persiste.',
    de: 'Es ist ein unerwarteter Fehler aufgetreten. Bitte versuchen Sie es erneut oder kontaktieren Sie den Support, wenn das Problem weiterhin besteht.',
    nl: 'Er is een onverwachte fout opgetreden. Probeer het opnieuw of neem contact op met de ondersteuning als het probleem aanhoudt.',
  },
  featureComingSoon: {
    id: `${accountProfileScope}.featureComingSoon`,
    defaultMessage:
      'Cette fonctionnalité sera (très) bientôt disponible. Encore un peu de patience.',
    en: 'This feature will be available (very) soon. Please be patient.',
    es: 'Esta funcionalidad estará disponible (muy) pronto. Solo un poco de paciencia.',
    it: "Questa funzionalità sarà disponibile (molto) presto. Ancora un po' di pazienza.",
    de: 'Diese Funktion wird (sehr) bald verfügbar sein. Noch ein wenig Geduld.',
    nl: 'Deze functie is (heel) binnenkort beschikbaar. Nog even geduld.',
  },
};

export default defineMessages(accountProfileMessages);
